import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    // console.log("trix-disable-attachments");
    // Disable trix uploads: https://github.com/basecamp/trix/issues/604#issuecomment-600974875
    // Get rid of the upload button
    this.element.addEventListener("trix-initialize", function(e) {
      // console.log("trix-initialize");
      const fileTools = document.querySelector(".trix-button-group--file-tools");
      // null check hack: trix-initialize gets called twice for some reason, sometimes it is null :shrug:
      fileTools?.remove();
    });
    // Dont allow images/etc to be pasted
    this.element.addEventListener("trix-attachment-add", function(event) {
      // console.log("trix-attachment-add");
      if (!event.attachment.file) {
        event.attachment.remove()
      }
    })
    // No files, ever
    this.element.addEventListener("trix-file-accept", function(event) {
      // console.log("trix-file-accept");
      event.preventDefault();
    });
  }
}
